import { useContext } from 'react';
import { OrderFlowContext } from '../../providers/OrderFlowProvider';

export default function useOrderFlow() {
  return useContext(OrderFlowContext);
}
